import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { useSelector } from 'react-redux';

import { getUrls } from '@/utils/urls/getUrls';

import btu_logo from '@/assets/images/logo.svg';
import smartcity_logo from '@/assets/images/logo_smartcity.svg';

const AuthPageWrapper = ({ 
	pageTitle, 
	children, 
	backgroundClassName = 'login__background',
	containerClassName = 'login__container',
	wrapperClassName = 'login__wrapper',
}) => {
	const dict = useSelector(state => state.app.dict);
	const isLoggedIn = useSelector(state => state.auth.isLoggedIn);

	const { simpleText, externalurls } = getUrls();
	const { pcssUrl, poznanCityUrl, uamUrl } = externalurls;

	const { t1, t2, t3, t4, t5, t6 } = dict.letter.footer;

	const getGeneratedAuthFooterLink = (label, link) => (
		<a
			target='_blank'
			href={ link }
			rel='noopener noreferrer'
		>
			{ label }
		</a>
	);

	return (
		<main className='login__main'>
			<div className={ containerClassName }>
				<div className={ wrapperClassName }>
					<section className='login__header'>
						<Link 
							to={ isLoggedIn ? simpleText : '/login' }
						>
							<img
								src={ btu_logo }
								alt='btu-logo'
								className='login__header--logo'
							/>
						</Link>
						<h1 className='login__header--title'>
							{ pageTitle }
						</h1>
					</section>

					{ children }

					<section className='login__footer'>
						<span className='login__footer--text'>
							{ t1 }&nbsp;

							{ getGeneratedAuthFooterLink(`${t2}`, pcssUrl ) }

							&nbsp;{ t3 }&nbsp;

							{ getGeneratedAuthFooterLink(t4, poznanCityUrl ) }

							&nbsp;{ t5 }&nbsp;

							{ getGeneratedAuthFooterLink(t6, uamUrl ) }
						</span>

						<img
							src={ smartcity_logo }
							alt='smarcity-logo'
							className='login__footer--logo'
						/>
					</section>
				</div>
			</div>

			<div className={ backgroundClassName } />
		</main>
	);
};

AuthPageWrapper.propTypes = {
	pageTitle: PropTypes.string,
	children: PropTypes.any,
	backgroundClassName: PropTypes.string,
	containerClassName: PropTypes.string,
	wrapperClassName: PropTypes.string,
};

export default AuthPageWrapper;